import { DashedTitle, Icon } from '@fasstech/middle-design-system';
import { ControlledRadioButton } from '@@viewCommonComponents/controlled/index.js';
import { isRequiredSelect } from '@@viewHelpers/validations/index.js';
import { mapIndexed } from '@@serverHelpers/index.mjs';

const GetSimulationNeeds = ({ form, name, postes, levels }) => {
  return (
    <div className={'flex flex-col gap-8'}>
      {mapIndexed((need, index) => {
        return (
          <div
            key={`need-${name}-${index}`}
            className={`flex flex-col gap-2 items-center ${form.watch(`${name}.${index - 1}.level`) || index === 0 ? '' : 'hidden'}`}>
            <Icon name={need.value} className={'mx-auto'} height={100} width={100} />
            <DashedTitle key={`need-${index}`}>{need.label}</DashedTitle>
            <ControlledRadioButton
              className={'gap-4'}
              name={`${name}.${index}.level`}
              options={levels}
              isResponsiveCol
              data-testid={`need${need.label}`}
              rules={isRequiredSelect(levels, true)}
              form={form}
            />
          </div>
        );
      }, postes)}
    </div>
  );
};

export default GetSimulationNeeds;
